import { useState, useEffect, useContext } from 'react'
import EnvContext from '../context/EnvContext'

import { gql, useQuery } from '@apollo/client';
import { THREE_MINUTES } from './pollIntervals'


const COMPANY_QUERY = gql`
query($envName: String!) {
    company(
        where: {
            environment: {
                name: {_eq: $envName }
            }
        }) {
          companyAbbreviation
          companyName
          id
    }
}
`

const FIX_COMPANY_QUERY = gql`
query($envName: String!) {
    FixConnectionToCompany(where: {envName: {_eq: $envName}}) {
            companyName
            fixSessionId
            id
    }
}
`

const CONN_COMPANY_QUERY = gql`
query ($envName: String!) {
    connection(where: {connectionType: {environment: {name: {_eq: $envName}}}}) {
      companyName
      id
    }
  }
`

export const useCompany = () => {

    const envSelected = useContext(EnvContext)
    const [lookupData, setLookupData] = useState({})
    const { data, loading } = useQuery(COMPANY_QUERY, {
        variables: {
            "envName": envSelected,
        }, pollInterval: THREE_MINUTES
    })

    

    useEffect(() => {
        if (!loading && data) {
            setLookupData(data.company.reduce((acc, d) => {
                if (d)
                    acc[d.id] = {
                        'id': d.id,
                        'name': d.companyName,
                        'abbreviation': d.companyAbbreviation
                    }
                return acc
            }, {}))
        }
    }, [data, loading])

    return lookupData
}

export const useCompanyFix = (env="") => {

    const envSelected = useContext(EnvContext)
    const [lookupData, setLookupData] = useState({})
    const { data, loading } = useQuery(FIX_COMPANY_QUERY, {
        variables: {
            "envName": env ? env :envSelected,
        }, pollInterval: THREE_MINUTES
    })

    

    useEffect(() => {
        if (!loading && data) {
            setLookupData(data.FixConnectionToCompany.reduce((acc, d) => {
                if (d)
                    acc[d.fixSessionId] = {
                        'id': d.fixSessionId,
                        'name': d.companyName
                    }
                return acc
            }, {}))
        }
    }, [data, loading])

    return lookupData
}

export const useCompanyConn = (env="") => {

    const envSelected = useContext(EnvContext)
    const [lookupData, setLookupData] = useState({})
    const { data, loading } = useQuery(CONN_COMPANY_QUERY, {
        variables: {
            "envName": env ? env : envSelected,
        }, pollInterval:  THREE_MINUTES
    })

    

    useEffect(() => {
        if (!loading && data) {
            setLookupData(data.connection.reduce((acc, d) => {
                if (d)
                    acc[d.id] = {
                        'id': d.id,
                        'name': d.companyName
                    }
                return acc
            }, {}))
        }
    }, [data, loading])

    return lookupData
}

